module.exports = __webpack_public_path__ + "media/cover_2400.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/cover_2400.jpg
// module id = 20
// module chunks = 0